module.exports = __webpack_public_path__ + "img/img_jp2.76f41fe0.jpg";